module.exports = __webpack_public_path__ + "img/mainInfo.754b103a.png";